import { SearchInputStore } from '../search_input/search_input_store';
import { observable } from 'mobx';

export class OSInputStore {
  @observable.ref
  os: string | undefined;

  search: SearchInputStore;

  constructor(name: string | undefined) {
    this.os = name;
    this.search = new SearchInputStore();
  }

  commitType = (value: string): void => {
    this.os = value;
  };

  removeType = (): void => {
    this.os = undefined;
  };
}
